import Quill from "quill";
import "quill/dist/quill.snow.css";

export function getQuillEditor({elementSelector}){
    const quill = new Quill(elementSelector, {
        modules: {
            toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline"],
                [
                    { list: "ordered" },
                    { list: "bullet" },
                    { indent: "-1" },
                    { indent: "+1" },
                ],
                ["link"],
                [{ script: "super" }, { script: "sub" }],
            ],
        },
        placeholder: "",
        theme: "snow",
    });
    return quill
}